
import api from '@/common/libs/api'
export default {
  state: {
    first: true, //第一次加载的标识
    coursesList: [], //课程列表
    consultantInfo: {},  //电话信息
    msg: null,   //标识是否有错误
    isTouchEnd: false,  //标示是否已经没有数据了
    noResult: false,   //第一次就没有找到匹配的结果
    conditions: {//查询条件，每次更新时只更新局部条件
      city: '',
      category: '10002',
      teaching_mode: 1003,
      type: '',
      grade: '9',
      phone: '',
      term: '',
      subject: '',
      pn: 1,  //页数
      rn: 5,    //每页显示课程数
      school_id: '',
      channel: 'izk_mobile',
      version: 99999
    }
  },
  mutations: {
    resetGroupOnline(state) {
      state.coursesList = [];
      state.first = true;
      state.isTouchEnd = false;
      state.noResult = false;
      state.conditions = {
        city: '',
        category: '10002',
        teaching_mode: 1003,
        type: '',
        grade: '9',
        phone: '',
        term: '',
        subject: '',
        pn: 1,  //页数
        rn: 5,    //每页显示课程数
        school_id: '',
        channel: 'izk_mobile',
        version: 99999              
      }
    },
    initGroupOnlineCoursesList(state, payload) {
      state.conditions = payload.conditions;
      if (state.first) {
        state.coursesList = payload.coursesList;
      } else {
        state.coursesList = state.coursesList.concat(payload.coursesList);
      }
      state.consultantInfo = payload.consultantInfo;
      state.msg = payload.msg;
      state.first = false;
      state.noResult = false;
    },
    setIsEnd(state, payload) {
      if (state.first) {
        state.noResult = true;
      } else {
        state.isTouchEnd = payload;
      }
    }
  },
  actions: {
    initGroupOnlineCoursesList(context, preload) {
      return api.apiMethod.coursesList.post(preload.conditions).then(res => {
        let content = res.data.content;
        if (res.data.errid == 0) {
          if (content.courses_list.length == 0) {
            context.commit('setIsEnd', true);
            return;
          }
          context.commit('initGroupOnlineCoursesList', {
            conditions: preload.conditions,
            coursesList: content.courses_list,
            consultantInfo: content.consultant_info,
            msg: content.msg.msg
          });

          preload.$state && preload.$state.loaded();
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/modules/courseCenter/groupOnline.js